import { useCallback, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { BsCalendarWeekFill } from 'react-icons/bs';

import { BookingCalendar } from 'components/bookingCalendar';
import { formatDate } from 'lib';
import { dateFormatStr } from '../../constants';
import { useOnClickOutside } from '../../hooks';
import {
    setCalendarAlert,
    setCalendarOpen,
    setTempCheckOutDay,
} from 'features/userSlice';

import './BookingPopoverCalendar.css';
import { Modal } from 'components/common/modal';
import { closeModal, openModal } from 'features/modalSlice';

const BookingPopoverCalendar = ({ isOpenCalendarModal = false }) => {
    const dispatch = useDispatch();
    const isOpen = useSelector((state) => state.user?.isCalendarOpen);

    const setIsOpen = (isOpen) => {
        if (isOpenCalendarModal) {
            dispatch(openModal({ modalId: 'CalendarModal' }));
        }
        dispatch(setCalendarOpen({ isCalendarOpen: isOpen }));
    };
    const colors = useSelector(
        (state) => state.miniBookingWidget?.data?.colors
    );
    const Lang = useSelector((state) => state.miniBookingWidget?.data?.Lang);
    const userCountryCode =
        useSelector((state) => state.user?.language) || 'en-US';

    const tempCheckInDate = useSelector(
        (state) => state.user?.checkInDay?.date
    );
    const tempCheckOutDate = useSelector(
        (state) => state.user?.checkOutDay?.date
    );

    const [currentMonthIndex, setCurrentMonthIndex] = useState(0);

    const bookingCalendarRef = useRef(null);

    const handleModalClose = useCallback(() => {
        dispatch(closeModal({ modalId: 'CalendarModal' }));
    });

    const handleClickOutside = useCallback(() => {
        setIsOpen(false);
        dispatch(setTempCheckOutDay({ day: null }));
        dispatch(setCalendarAlert({ msg: '' }));
        if (isOpenCalendarModal) {
            dispatch(closeModal({ modalId: 'CalendarModal' }));
        }
    }, []);

    useOnClickOutside(bookingCalendarRef, handleClickOutside);

    if (!tempCheckInDate || !tempCheckOutDate) {
        return null;
    }

    const renderBookingCalendar = () => (
        <BookingCalendar
            currentMonthIndex={currentMonthIndex}
            setCurrentMonthIndex={setCurrentMonthIndex}
            // variant="singleMonth"
        />
    );

    let renderContent = null;
    if (isOpenCalendarModal) {
        renderContent = renderBookingCalendar;
    }

    return (
        <div className="ab-dates-container" ref={bookingCalendarRef}>
            <div className="ab-dates-inner" onClick={() => setIsOpen(!isOpen)}>
                <div className="ab-filter">
                    <div className="ab-filter-group">
                        <div className="ab-input ab-checkin-container">
                            <span
                                className="ab-date"
                                role="button"
                                tabIndex="0"
                            >
                                <span className="ab-prefixIcon">
                                    <BsCalendarWeekFill size={17} />
                                </span>
                                <span className="ab-value">
                                    {formatDate(
                                        new Date(tempCheckInDate),
                                        dateFormatStr,
                                        userCountryCode
                                    )}
                                </span>
                            </span>
                        </div>

                        <div className="ab-dateSeparator"></div>

                        <div className="ab-input ab-checkout-container">
                            <span
                                className="ab-date"
                                role="button"
                                tabIndex="0"
                            >
                                <span className="ab-prefixIcon">
                                    <BsCalendarWeekFill size={17} />
                                </span>
                                <span className="ab-value">
                                    {formatDate(
                                        new Date(tempCheckOutDate),
                                        dateFormatStr,
                                        userCountryCode
                                    )}
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="ab-popup" id="ab-calendar-dropdown">
                <div className="ab-calendar-dropdown-wrapper">
                    {isOpenCalendarModal
                        ? isOpen && (
                              <Modal
                                  className="ab-modal--contact-us"
                                  color={colors?.primaryTextColor}
                                  backgroundColor={
                                      colors?.primaryBackgroundColor
                                  }
                                  isOpen={isOpen}
                                  onClose={handleModalClose}
                                  onOverlayClick={handleModalClose}
                                  placement="center"
                                  renderContent={renderContent}
                                  styles={{
                                      closeIcon: {
                                          color: colors?.primaryTextColor,
                                      },
                                  }}
                                  title={Lang?.contactUs}
                                  variant="secondary"
                                  width={1050}
                              />
                          )
                        : isOpen && (
                              <BookingCalendar
                                  currentMonthIndex={currentMonthIndex}
                                  setCurrentMonthIndex={setCurrentMonthIndex}
                                  //   variant="singleMonth"
                              />
                          )}
                </div>
            </div>
        </div>
    );
};

BookingPopoverCalendar.propTypes = {
    isOpenCalendarModal: PropTypes.bool,
};

export default BookingPopoverCalendar;
